import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private readonly _router: Router) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (localStorage.getItem("token")) {
      return true;
    }
    return this._router.createUrlTree(["home/auth/login"], {
      queryParams: { returnUrl: state.url },
    });
  }

  canActivateChild(
    _childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (localStorage.getItem("token")) {
      return true;
    }
    return this._router.createUrlTree(["home/auth/login"], {
      queryParams: { returnUrl: state.url },
    });
  }
}
